import {Component, OnInit, DestroyRef, inject, signal, ChangeDetectorRef, ElementRef, ViewChild, AfterViewInit} from '@angular/core';
import {
  faArrowRightFromBracket,
  faQuestionCircle,
} from '@fortawesome/free-solid-svg-icons';
import {KeycloakService} from 'keycloak-angular';
import {CookieService} from 'ngx-cookie-service';
import {Router, RouterOutlet, NavigationEnd} from '@angular/router';
import {FaIconComponent} from '@fortawesome/angular-fontawesome';
import {CommonModule, NgOptimizedImage} from '@angular/common';
import {SpinnerComponent} from '../../../shared/components/spinner/spinner.component';
import {Favicons} from '../../../app.constants';
import {environment} from '../../../../environments/environment';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatSidenavContainer} from '@angular/material/sidenav';
import {SidenavComponent} from '../../../shared/components/sidenav/sidenav.component';
import {SidebarComponent} from '../../../shared/components/sidebar/sidebar.component';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {filter} from 'rxjs/operators';
import {AuthService} from 'src/app/shared/services/auth.service';

@Component({
  selector: 'app-frame',
  standalone: true,
  providers: [MatSidenavContainer],
  imports: [
    CommonModule,
    SpinnerComponent,
    FaIconComponent,
    RouterOutlet,
    MatToolbarModule,
    SidenavComponent,
    SidebarComponent,
    NgOptimizedImage
  ],
  templateUrl: './frame.component.html',
  styleUrl: './frame.component.scss'
})
export class FrameComponent implements OnInit, AfterViewInit {
  @ViewChild('mainContent') mainContent!: ElementRef<HTMLDivElement>;

  activeSubMenu: string | null = null;
  isSubmenuVisible: boolean = false;

  collapsed: any = signal(false);

  private readonly keycloak = inject(KeycloakService);
  private cookieService = inject(CookieService);
  protected router = inject(Router);
  private authService = inject(AuthService);
  private cd = inject(ChangeDetectorRef);
  private destroyRef = inject(DestroyRef);

  protected readonly faLogout = faArrowRightFromBracket;
  protected readonly faQuestionCircle = faQuestionCircle;

  protected env = environment;

  get logoSmartTomm() {
    return this.env.envName === 'test' || this.env.envName === 'stage' ? '-test' : '';
  }

  get client4SmwUrl(): string {
    return this.authService.getCurrentClient();
  }

  get footerBaseUrl(): string {
    return this.client4SmwUrl === 'sug'
      ? 'https://www.sommer-gossmann.com'
      : 'https://www.em-sourcing.com';
  }

  get hasManagerOrEmployeeRole(): boolean {
    return this.authService.hasManagerOrEmployeeRole();
  }

  ngOnInit() {
    this.initFavicon();
    this.collapsed.set(true);

    this.cd.detectChanges();

    // Listen to router events to reset activeSubMenu when navigating to /home
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe((event) => {
        const navEvent = event as NavigationEnd;
        // Reset activeSubMenu when navigating to the global /home route
        if (navEvent.url === '/home' || navEvent.url === '/') {
          this.activeSubMenu = null;
          this.isSubmenuVisible = false;
        }
      });

    if (this.keycloak.isLoggedIn() && !sessionStorage.getItem('filters_cleaned')) {
      console.log('[Frame] ngOnInit clearSpecificStorageItems');
      this.clearSpecificStorageItems();
      sessionStorage.setItem('filters_cleaned', 'true');
    }
  }
  ngAfterViewInit() {
    const excludedRoutes = ['/home'];
    this.router.events
      .pipe(
        filter((event): event is NavigationEnd => event instanceof NavigationEnd)
      )
      .subscribe(event => {

        if (!excludedRoutes.some(route => event.urlAfterRedirects.startsWith(route))) {
          this.mainContent.nativeElement.scrollTo({ top: 0 });
        }

      });
  }

  onNavigate(path: string) {
    path = path || '/home';

    this.cookieService.set('verwaltung', path);
    this.router.navigateByUrl(path);
  }

  private initFavicon() {
    document.getElementById('favicon')?.setAttribute('href', Favicons.Base);
    document.getElementById('favicon16')?.setAttribute('href', Favicons.Base16);
    document.getElementById('favicon32')?.setAttribute('href', Favicons.Base32);
  }

  private clearSpecificStorageItems(): void {
    const keysToRemove: string[] = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && (key.startsWith('filters_') || key.startsWith('search_'))) {
        keysToRemove.push(key);
      }
    }
    keysToRemove.forEach(key => localStorage.removeItem(key));
  }

  async logout() {
    console.log('[Frame] logout clearSpecificStorageItems');
    sessionStorage.removeItem('filters_cleaned');
    this.clearSpecificStorageItems();
    await this.keycloak.logout();
  }
}
